import * as React from 'react';

const ThreeDotsIcon = ({ color = '#0E1323' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.5 10.5C5.675 10.5 5 11.175 5 12C5 12.825 5.675 13.5 6.5 13.5C7.325 13.5 8 12.825 8 12C8 11.175 7.325 10.5 6.5 10.5ZM12 10.5C11.175 10.5 10.5 11.175 10.5 12C10.5 12.825 11.175 13.5 12 13.5C12.825 13.5 13.5 12.825 13.5 12C13.5 11.175 12.825 10.5 12 10.5ZM16 12C16 11.175 16.675 10.5 17.5 10.5C18.325 10.5 19 11.175 19 12C19 12.825 18.325 13.5 17.5 13.5C16.675 13.5 16 12.825 16 12Z"
      fill={color}
      fillOpacity="0.5"
    />
  </svg>
);
export default ThreeDotsIcon;
